import { JSX, useEffect, useState } from "react";
import { Col, Modal, Row } from "antd";
import dayjs from "dayjs";
import styled from "styled-components";
import Button from "../../components/Button/Button";
import Text from "../../components/Text/Text";
import Select from "../../components/Select/Select";
import color from "../../resource/color";

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }
`;

// Mock year list (Buddhist era) until the API for available tier-program years is wired in.
const currentBuddhistYear = dayjs().year() + 543;

interface Props {
  open: boolean;
  availableYears : Array<{ key: number; tierProgramId: string; year: number }>;
  loading?: boolean;
  onCancel: () => void;
  onExport: (year: string) => void;
}

function ExportShopTierModal({ open, availableYears, loading, onCancel, onExport }: Props): JSX.Element {
  const [year, setYear] = useState<string>(availableYears?.[0]?.tierProgramId);

  // Start from the current year every time the modal opens.
  useEffect(() => {
    if (open) setYear(availableYears?.[0]?.tierProgramId);
  }, [open]);

  return (
    <ModalStyled open={open} centered closable={false} footer={null} onCancel={onCancel} width={520}>
      <Text level={2} fontWeight={700}>
        Export ข้อมูลระดับร้านค้า
      </Text>

      <div style={{ marginTop: 16 }}>
        <Text fontFamily='Sarabun' fontSize={14} color='Text2'>
          เลือกปีที่ต้องการ
        </Text>
        <Select
          data={availableYears.map((year) => ({ key: year.tierProgramId, value: year.tierProgramId, label: `ปี ${year.year}` })) || []}
          value={year}
          allowClear={false}
          onChange={(v) => setYear(v)}
          style={{ width: "100%", marginTop: 8 }}
        />
      </div>

      <div style={{ marginTop: 16, paddingBottom: 16, borderBottom: `1px solid ${color.border}` }}>
        <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
          ข้อมูล ณ วันนี้ ตามคำค้นและตัวกรองที่เลือกไว้
        </Text>
      </div>

      <Row justify='end' gutter={12} style={{ marginTop: 24 }}>
        <Col>
          <Button
            typeButton='border-primary'
            title='ยกเลิก'
            style={{ width: 120 }}
            onClick={onCancel}
          />
        </Col>
        <Col>
          <Button
            typeButton='primary'
            title='Export'
            style={{ width: 120 }}
            loading={loading}
            onClick={() => onExport(year)}
          />
        </Col>
      </Row>
    </ModalStyled>
  );
}

export default ExportShopTierModal;
